"use client";

import { useEffect } from "react";
import { useSearchParams, useRouter } from "next/navigation";

export const RedirectIfReference = () => {
    const searchParams = useSearchParams();
    const router = useRouter();
  
    useEffect(() => {
        if (searchParams.get("reference")) {
            router.replace("/register/step-1");
        }
    }, [searchParams, router]);
  
    return null;
}
